module.exports = __webpack_public_path__ + "img/circle_trash_delete.2246f7f0.png";